import axios from "axios";
import baseUrl from "../config";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const signin = async (values) => {
  try {
    const response = await axiosInstance.post("/pizza-api/users/login", values);
    return response.data;
  } catch (err) {
    console.log(err);
    return { error: err };
  }
};

const signout = async () => {
  try {
    const response = await axiosInstance.get("/pizza-api/users/logout");
    clearToken();
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

function authenticate(token) {
  if (typeof window !== "undefined")
    sessionStorage.setItem("token", JSON.stringify(token));
}

function isAuthenticated() {
  if (typeof window == "undefined") return false;

  if (!sessionStorage.getItem("token")) return false;

  return JSON.parse(sessionStorage.getItem("token"));
}

function clearToken() {
  if (typeof window !== "undefined") sessionStorage.removeItem("token");
}

export { authenticate, isAuthenticated, clearToken, signin, signout };
